var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVegan = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4251 13.0833C17.8151 18.6933 18.3468 28.32 18.3468 28.32C18.3468 28.32 27.9734 28.8517 33.5834 23.2417C36.4618 20.3633 37.7234 16.4267 38.2701 13.275C38.7668 10.4167 36.2501 7.89999 33.3918 8.39666C30.2418 8.94166 26.3051 10.2033 23.4251 13.0833Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M6.41664 19.9083C12.0266 25.5183 21.6533 24.9867 21.6533 24.9867C21.6533 24.9867 22.185 15.36 16.575 9.75001C13.6966 6.87168 9.75997 5.61001 6.60831 5.06335C3.74997 4.56668 1.23331 7.08335 1.72997 9.94168C2.27497 13.0917 3.53664 17.0283 6.41664 19.9083Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 27.5C23.3333 26.12 22.2133 25 20.8333 25C19.4533 25 18.3333 26.12 18.3333 27.5C18.3333 28.1433 18.3333 33.5233 18.3333 34.1667C18.3333 35.5467 19.4533 36.6667 20.8333 36.6667C22.2133 36.6667 23.3333 35.5467 23.3333 34.1667C23.3333 33.5233 23.3333 28.1433 23.3333 27.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegan.3956cb27.svg";
export { ForwardRef as ReactComponent };